import { useMutation } from '../useMutation/index'
import { templateQueries } from './graphql'
import { useConfirmDialog } from '../useConfirmDialog'

export const useDeleteTemplate = () => {
  const mutationOptions = { refetchQueries: ['allTemplate'] }

  const [onDeleteHandler] = useMutation({ ...templateQueries.deleteConfig, options: { mutationOptions } })

  const { confirm } = useConfirmDialog({
    title: 'Delete template?',
    text: 'Are you sure you want to delete the template?',
  })

  const onDelete = async (templateId: string) => {
    await confirm(async () => {
      //do the submission here
      const { errors, data } = await onDeleteHandler({ _id: templateId })
      if (errors) throw errors
      return data?.deleteTemplate
    })
  }

  return { onDelete }
}
